"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ = require("..");
var _redux = require("redux");
var _reactRedux = require("react-redux");
var _awsAmplify = require("aws-amplify");
var _languages = require("./../../modules/languages");
var _reactSelect = _interopRequireDefault(require("react-select"));
var _v = _interopRequireDefault(require("uuid/v1"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const mapStateToProps = (state, props) => {
  return {
    [props.entity.plural]: state[props.entity.plural]
  };
};
const mapDispatchToProps = (dispatch, props) => {
  return {
    create: (0, _redux.bindActionCreators)(props.actions.create, dispatch)
  };
};
class CreateLanguagesTable extends _react.default.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "handleChange", selectedLanguage => {
      this.setState({
        selectedLanguage: selectedLanguage
      });
    });
    _defineProperty(this, "throw", message => {
      this.setState(prev => {
        return {
          errors: [{
            Id: (0, _v.default)(),
            Message: message
          }]
        };
      });
    });
    _defineProperty(this, "message", message => {
      this.setState(prev => {
        return {
          messages: [{
            Id: (0, _v.default)(),
            Message: message
          }]
        };
      });
    });
    _defineProperty(this, "onSubmit", event => {
      {
        event.preventDefault && event.preventDefault();
      }
      const {
        entity,
        history,
        create,
        [this.props.entity.plural]: store
      } = this.props;
      let payload = {
        Code: this.state.selectedLanguage.value,
        DisplayName: this.state.selectedLanguage.label,
        LanguageImage: "",
        Published: this.state.isPublished
      };
      const onSubmitSuccess = store.create && store.create.form && store.create.form.onSubmitSuccess ? store.create.form.onSubmitSuccess : undefined;
      this.setState({
        fetching: true
      });
      _awsAmplify.Auth.currentSession().then(data => {
        create(payload, data.idToken.jwtToken).then(response => {
          this.setState({
            fetching: false
          });
          onSubmitSuccess ? onSubmitSuccess(this.props) : history.push(`/${entity.plural}/${response.Id}`);
        }).catch(error => {
          console.dir(error);
          this.throw(error.Message ? error.Message : `Oops, something went wrong.`);
          this.setState({
            fetching: false
          });
        });
      }).catch(error => {
        console.dir(error);
        this.throw(error.Message ? error.Message : `Oops, something went wrong.`);
        this.setState({
          fetching: false
        });
      });
    });
    this.state = {
      fetching: false,
      languagesList: _languages.languagesList,
      isPublished: false,
      selectedLanguage: null,
      errors: []
    };
  }
  handleCheck(value) {
    var published = this.state.isPublished;
    this.setState({
      isPublished: !published
    });
  }
  onRead(id) {
    this.setState(prev => {
      return {
        errors: prev.errors.filter(error => error.Id !== id),
        messages: prev.messages.filter(message => message.Id !== id)
      };
    });
  }
  render() {
    const {
      fetching,
      languagesList,
      isPublished,
      selectedLanguage,
      errors
    } = this.state;
    if (fetching) return /*#__PURE__*/_react.default.createElement(_.Spinner, null);
    return /*#__PURE__*/_react.default.createElement("div", null, !!errors.length && errors.map(error => /*#__PURE__*/_react.default.createElement("div", {
      key: error.Id,
      className: 'alert alert-danger alert-dismissible fade show'
    }, error.Message.length < 200 ? error.Message : "Oops, something went wrong.", /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: "close",
      "data-dismiss": "alert",
      "aria-label": "Close",
      onClick: () => this.onRead(error.Id)
    }, /*#__PURE__*/_react.default.createElement("span", {
      "aria-hidden": "true"
    }, "\xD7")))), /*#__PURE__*/_react.default.createElement("form", {
      onSubmit: this.onSubmit
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: `form-group mb-4`,
      style: {
        zIndex: "10"
      }
    }, /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: "Name",
      className: 'text-muted small text-uppercase'
    }, "Language"), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_reactSelect.default, {
      value: selectedLanguage,
      onChange: this.handleChange,
      options: languagesList
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: `form-group`,
      style: {
        zIndex: "0"
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "custom-control custom-checkbox",
      style: {
        zIndex: "0"
      }
    }, /*#__PURE__*/_react.default.createElement("input", {
      type: "checkbox",
      className: "form-check-input",
      id: "Published",
      checked: isPublished,
      onChange: event => this.handleCheck(event.target.checked)
    }), /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: "Published",
      className: 'small text-muted text-uppercase'
    }, "Published"))), selectedLanguage ? /*#__PURE__*/_react.default.createElement("button", {
      className: 'btn btn-primary mt-4',
      type: 'submit'
    }, "Create") : /*#__PURE__*/_react.default.createElement("button", {
      className: 'btn btn-primary disabled mt-4',
      type: 'submit',
      disabled: true
    }, "Create")));
  }
}
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CreateLanguagesTable);
module.exports = exports.default;